import { removeMark, toggleMark } from '@atlaskit/editor-common/mark';
import { ACTIONS, pluginKey } from '../main';
import { overrideMarks } from '../utils/constants';
import { getDisabledState } from '../utils/disabled';
export var toggleColor = function toggleColor(color) {
  return function (state, dispatch) {
    var textColor = state.schema.marks.textColor;
    var tr = state.tr;
    var disabledState = getDisabledState(state);
    if (disabledState) {
      if (dispatch) {
        dispatch(tr.setMeta(pluginKey, {
          action: ACTIONS.DISABLE
        }));
      }
      return false;
    }
    if (dispatch) {
      overrideMarks.forEach(function (mark) {
        var marks = tr.doc.type.schema.marks;
        if (marks[mark]) {
          removeMark(marks[mark])({
            tr: tr
          });
        }
      });
      toggleMark(textColor, {
        color: color
      })({
        tr: tr
      });
      dispatch(tr);
    }
    return true;
  };
};